import PurchaseTier from '@alltrails/core/types/PurchaseTier';
import { FormattedMessage } from 'react-intl';

const getCtaText = (tier: PurchaseTier, isPromoEligible?: boolean) => {
  if (isPromoEligible) {
    return <FormattedMessage defaultMessage="Start your free trial" />;
  }

  if (tier === 'peak') {
    return <FormattedMessage defaultMessage="Continue with Peak" />;
  }

  return <FormattedMessage defaultMessage="Continue with Plus" />;
};

export default getCtaText;
